"use client";

import React from "react";
import { defaultTheme } from "@/src/config/colors";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  error,
  className = "",
  checked,
  ...props
}) => {
  return (
    <label className="flex items-center gap-2.5 cursor-pointer group">
      <div className="relative">
        <input
          type="checkbox"
          className="peer sr-only"
          checked={checked}
          {...props}
        />
        <div
          className={`
            w-4 h-4 rounded border flex items-center justify-center transition-all
            ${checked 
              ? "bg-[#F26250] border-[#F26250]" 
              : "bg-white border-gray-300 group-hover:border-[#F26250]"
            }
          `}
        >
          {checked && (
            <svg
              className="w-3 h-3 text-white"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
        </div>
      </div>
      {label && (
        <span className="text-sm transition-colors group-hover:text-[#1D1D1D]" style={{ color: "#6E6E73" }}>
          {label}
        </span>
      )}
      {error && <span className="text-xs text-red-500">{error}</span>}
    </label>
  );
};